import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  cancelJob,
  dismissJob,
  enqueueFootageJob,
  getActiveUploadForMatch,
  getBackgroundUploadJobs,
  retryJob,
  subscribeBackgroundUploads,
} from '../lib/backgroundUploadManager';
import UploadProgressBubble from '../components/UploadProgressBubble';

const BackgroundUploadContext = createContext(null);

export function BackgroundUploadProvider({ children }) {
  const [jobs, setJobs] = useState(() => getBackgroundUploadJobs());

  useEffect(() => subscribeBackgroundUploads(setJobs), []);

  const value = useMemo(() => ({
    jobs,
    enqueueFootageJob,
    retryJob,
    cancelJob,
    dismissJob,
    getActiveUploadForMatch,
  }), [jobs]);

  return (
    <BackgroundUploadContext.Provider value={value}>
      {children}
      <UploadProgressBubble jobs={jobs} onRetry={retryJob} onCancel={cancelJob} onDismiss={dismissJob} />
    </BackgroundUploadContext.Provider>
  );
}

export function useBackgroundUpload() {
  const ctx = useContext(BackgroundUploadContext);
  if (!ctx) {
    return {
      jobs: [],
      enqueueFootageJob,
      retryJob,
      cancelJob,
      dismissJob,
      getActiveUploadForMatch,
    };
  }
  return ctx;
}

export function useMatchFootageUpload(matchId) {
  const { jobs } = useBackgroundUpload();
  if (!matchId) return null;
  return jobs.find((job) => (
    (job.gameMatchIds || []).includes(matchId)
    && !['complete', 'cancelled'].includes(job.status)
  )) || null;
}
